import {
  POST_POS_CATALOG,
  POST_POS_CATALOG_SUCCESS,
  POST_POS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const postPosCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case POST_POS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case POST_POS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_POS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
